import React from 'react';
import { Typography, Tabs } from 'antd';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import MarketingUserDetailForm from '../../components/user/userDetailForm';
import BrandList from './BrandList';
import MarketingTeam from './MarketingTeam';
import requireAuth from '../../hocs/requireAuth';
import {
  refreshUserDetails,
  userMangement,
} from '../../redux/actions/authActions';
import { CHANGE_SELECTED_COMPANY } from '../../constants/actionTypes';
import { ROLE_MARKETING_ADMIN } from '../../constants/roles';

const { Text } = Typography;

function MarketingUserScreen() {
  const selectedCompany = useSelector((state) =>
    get(state, 'auth.selectedCompany')
  );

  const dispatch = useDispatch();
  const role = useSelector((state) => get(state, 'auth.role.role_code'));
  const onRefreshSelectedCompany = () => {
    dispatch(
      userMangement('get.company', { company_id: get(selectedCompany, 'id') })
    ).then((result) => {
      dispatch({
        type: CHANGE_SELECTED_COMPANY,
        payload: get(result, 'data'),
      });
    });
  };

  const refreshUser = (refreshCompany = false) => {
    dispatch(refreshUserDetails()).then(() => {
      if (refreshCompany) {
        onRefreshSelectedCompany();
      }
    });
  };

  const hasEditRole = role === ROLE_MARKETING_ADMIN;
  return (
    <div>
      <div className="user-header">
        <div>
          <Text className="main-heading">User</Text>
        </div>
      </div>
      <div className="user-tab-container">
        <Tabs defaultActiveKey="1" animated={{ inkBar: true, tabPane: true }}>
          <Tabs.TabPane tab="User Details" key="1">
            <MarketingUserDetailForm refreshUser={refreshUser} />
          </Tabs.TabPane>
          {hasEditRole && (
            <Tabs.TabPane tab="Team" key="2">
              <MarketingTeam hasEditRole={hasEditRole} />
            </Tabs.TabPane>
          )}
          <Tabs.TabPane tab="Brands" key="3">
            <BrandList hasEditRole={hasEditRole} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
}

export default requireAuth(MarketingUserScreen);
